import axios from 'axios'



const API_BASE = process.env.REACT_APP_API_URL || 'https://aitrademinds.in'

const api = axios.create({
  baseURL: API_BASE,
})

// Auto-attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('atm_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Auto-logout on 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('atm_token')
      localStorage.removeItem('atm_plan')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export const authAPI = {
  register: (email: string, password: string, phone?: string) =>
    api.post('/api/auth/register', { email, password, phone }),

  login: (email: string, password: string) => {
    const formData = new FormData()
    formData.append('username', email)
    formData.append('password', password)
    return api.post('/api/auth/login', formData)
  },
}

export const signalsAPI = {
  getLatest: () => api.get('/api/signals/latest'),
  getHistory: (days: number = 1) => api.get(`/api/signals/history?days=${days}`),
  getAccuracy: () => api.get('/api/signals/accuracy'),  // ← add this
}
export const subscriptionAPI = {
  getStatus:   () => api.get('/api/subscriptions/status'),
  createOrder: (plan: string) => api.post(`/api/subscriptions/create-order?plan=${plan}`),
  verifyOrder: (orderId: string) => api.get(`/api/subscriptions/verify/${orderId}`),
}

export default api